export function formatPhoneNumber(phoneNumber: string) {
  // 国番号が+81の場合は、0から始まるようにする
  if (phoneNumber.startsWith('+81')) {
    return "0" + phoneNumber.slice(3)
  }

  // 国番号が+81以外の場合は、そのまま返却する
  return phoneNumber
}